import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { OverviewPanelData } from '@app/areas/dashboard/utils/overview.util';

/** A single overview stat tile. */
@Component({
  selector: 'app-dashboard-overview-panel-data',
  templateUrl: './dashboard-overview-panel-data.component.html',
  styleUrls: ['./dashboard-overview-panel-data.component.scss'],
  standalone: true,
  imports: [NgIf],
})
export class DashboardOverviewPanelDataComponent {
  @Input() data: OverviewPanelData | null = null;
}
